// extracted by mini-css-extract-plugin
module.exports = {"selectBoxIcon":"Select_selectBoxIcon__WsuBN","error":"Select_error__MDwOx","select":"Select_select__2_y_y","label":"Select_label__W9zjJ"};